import { Outlet } from 'react-router-dom';

// material-ui
import { styled, useTheme } from '@mui/material/styles';

// project imports
import TopNavigation from './TopNavigation';
import Footer from './Footer';
import OrderOnBehalfBar from 'ui-component/OrderOnBehalfBar';
import MaintenancePage from 'views/pages/maintenance';
import BlockingLoader from 'ui-component/BlockingLoader';
// import useAuth from 'hooks/useAuth';
import useMaintenance from 'hooks/useMaintenance';

// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    ...theme.typography.mainContent,
}));

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {

    const market_settings = useMaintenance();

    const theme = useTheme();
    return (
        <>
            <TopNavigation />
            <OrderOnBehalfBar />
            {/* main content */}
            <Main theme={theme}>
                {!market_settings ? <BlockingLoader text="Loading ..." /> : !!market_settings?.maintenance_mode ? <MaintenancePage/> : <Outlet />}
            </Main>

            <Footer />
        </>
    );
};

export default MainLayout;
